import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LotFormComponent } from './lot-form/lot-form.component';
import { BulkLotFormComponent } from './bulk-lot-form/bulk-lot-form.component';
import { AuctionAnnouncementComponent } from './auction-announcement/auction-announcement.component';
import { LotListingComponent } from './lot-listing/lot-listing.component';
import { CommonSharedModule } from '../../../shared/shared.module';
import { CoreModule } from '../../../core/core.module';
import { MatSliderModule } from '@angular/material/slider';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AdminSharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [LotFormComponent, BulkLotFormComponent, AuctionAnnouncementComponent, LotListingComponent],
  imports: [
    CommonModule,
    CommonSharedModule,
    AdminSharedModule,
    CoreModule,
    MatSliderModule,
    MatChipsModule,
    MatAutocompleteModule
  ],
  exports: [LotListingComponent]
})
export class ManageLotModule { }
